// YouTube Data API v3 service
// You'll need to add your API key to environment variables
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || 'YOUR_API_KEY_HERE';
const BASE_URL = 'https://www.googleapis.com/youtube/v3';

export const fetchVideoMetadata = async (videoId) => {
  try {
    const response = await fetch(
      `${BASE_URL}/videos?part=snippet,statistics&id=${videoId}&key=${API_KEY}`
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch video metadata');
    }
    
    const data = await response.json();
    
    if (data.items && data.items.length > 0) {
      const video = data.items[0];
      return {
        id: video.id,
        title: video.snippet.title,
        description: video.snippet.description,
        channelTitle: video.snippet.channelTitle,
        publishedAt: video.snippet.publishedAt,
        thumbnail: video.snippet.thumbnails?.high?.url || video.snippet.thumbnails?.medium?.url,
        viewCount: video.statistics?.viewCount,
        likeCount: video.statistics?.likeCount,
        duration: video.snippet.duration // Note: This requires additional API call
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching video metadata:', error);
    return null;
  }
};

export const extractVideoId = (url) => {
  const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}; 